import { Money, type SerializedMoney } from '@contra/money';

export const renderJobBudgetValue = (
  feeMin: SerializedMoney,
  feeMax: null | SerializedMoney,
  separatorCharacter = '-',
) => {
  if (feeMax === null) {
    return `${Money.deserialize(feeMin).formatRounded()}+`;
  }

  if (feeMin === feeMax) {
    return Money.deserialize(feeMin).formatRounded();
  }

  return [feeMin, feeMax]
    .map((fee) => {
      return Money.deserialize(fee).formatRounded();
    })
    .join(` ${separatorCharacter} `);
};
